import { request } from "../../../../services/api"
import type { BaseApiResponse } from "../../../../types/api.ts"
import type { ContractValidationResult } from "../types.ts"

const PATHS = {
  contractValidation: (id: string) => `/proposal/v2/contracts/${id}/validation/`
}

/**
 * `GET /proposal/v2/contracts/{id}/validation/` — the authoritative,
 * server-side recheck of a Contract's own Sales Price vs. Milestone Total
 * and Contract Duration vs. Milestone Duration, against whatever was just
 * saved. Only ever called at Generate time (the live-typing recalculation
 * uses `calculateContractValidation` locally, no network round trip).
 * Refuses with 400 on a non-latest version — never called from a read-only
 * historical Contract page in practice, since that page never renders the
 * Generate button this backs.
 */
export const getContractValidation = (contractId: string) =>
  request.api.get<ContractValidationResult, BaseApiResponse<unknown>>(
    PATHS.contractValidation(contractId)
  )
